import isUndefined from 'lodash/isUndefined';
import isFunction from 'lodash/isFunction';
import isArray from 'lodash/isArray';
import React from 'react';
import warn from '../../utils/warn';
import { connect } from 'reflux';
import langStore from '../../stores/lang';


const allTranslations = {
  'en': {
    'site-name': 'Kenya Forestry',
    'site.logo': 'MTI Calc',
    'site.footerlogo': 'Development Gateway',
    'nav.home': 'Home',
    'nav.data': 'Data',
    'lang.en': 'English',
    'lang.sw-tz': 'Kiswahili',
    'legend.title': 'Legend',
     
    'menu.counties': 'Counties',
    'menu.zones': 'Zones',
    'menu.projects': 'Environmental Projects',
    'popup.header': 'Project Information',
    'popup.project_id': 'Project ID',
    'popup.project_title': 'Project Title',
    'popup.draft_estimated': 'Draft Estimated 2015',
    'popup.duration': 'Duration',
    'popup.donor': 'Donor',
    'popup.funding_type': 'Funding Type',
    'popup.status': 'Status',
    'popup.implementing_agency': 'Implementing Agency',
    'popup.program': 'Program',
    'popup.project_description': 'Description',
    'popup.project_objectives': 'Objectives',
    'popup.total_estimates_for_2015': 'Total Estimates 2015',

  },

  'sw-tz': {
    'site-name': 'Kenya Forestry',
    'site.logo': 'MTI Calc',
    'site.footerlogo': 'Development Gateway',
    'nav.home': 'Home',
    'nav.data': 'Data',
    'lang.en': 'English',
    'lang.sw-tz': 'Kiswahili',
    'legend.title': 'Legend',

    'menu.counties': 'Counties',
    'menu.zones': 'Zones',
    'menu.projects': 'Environmental Projects',
    
    'popup.header': 'Project Information',
    'popup.project_id': 'Project ID',
    'popup.project_title': 'Project Title',
    'popup.draft_estimated': 'Draft Estimated 2015',
    'popup.duration': 'Duration',
    'popup.donor': 'Donor',
    'popup.funding_type': 'Funding Type',
    'popup.status': 'Status',
    'popup.implementing_agency': 'Implementing Agency',
    'popup.program': 'Program',
    'popup.project_description': 'Description',
    'popup.project_objectives': 'Objectives',
    'popup.total_estimates_for_2015': 'Total Estimates 2015',

  },
};


/**
 * @param {string} lang The language to translate to like 'en'
 * @param {string} k The key for the translation, like 'site.name'
 * @param {array<any>} i Any values to interpolate into the string
 * @returns {string} the translated string, or the key if it's missing
 */
function translate(lang, k, i) {
  const langTranslations = allTranslations[lang];
  if (isUndefined(langTranslations)) {
    // if the language key is bad, quit early
    warn(`missing language ${lang} to translate ${k}`);
    return k;
  }
  let translated = langTranslations[k];
  if (isUndefined(translated)) {
    warn(`missing translation for key: ${k}`);
    translated = k;
  } else if (isFunction(translated)) {
    if (!isArray(i)) {
      warn(`missing expected array for interpolating ${k}, got: ${i}`);
      translated = translated([]);
    } else {
      translated = translated(i);
    }
  }
  return translated;
}


const T = React.createClass({
  propTypes: {
    i: React.PropTypes.array,
    k: React.PropTypes.string.isRequired,
  },
  mixins: [
    connect(langStore, 'lang'),
  ],
  render() {
    const translated = translate(this.state.lang, this.props.k, this.props.i);
    return (
      <span className="t">{translated}</span>
    );
  },
});

export { translate };
export default T;



/** WEBPACK FOOTER **
 ** ./app/scripts/components/misc/t.jsx
 **/